import request from '@/utils/request';

/**
 * @description 获取用户列表
 * @param {string}  role
 * @param {string}  username
 * @param {string}  startTime
 * @param {string}  endTime
 * @param {string}  page
 * @param {string}  size
 * @returns {Object} table
 */

export function getUserTable(data) {
  return request.post('admin/user/list', data);
}

/**
 * @description 删除当前列
 * @param {string}  id
 * @returns {}
 */

export function deleteTable(data) {
  return request.post('admin/user/delete', data);
}

/**
 * @description 批量删除
 * @param {string}  batchID
 * @returns {}
 */

export function batchDeleteTable(data) {
  return request.post('/userManage/batchDeleteTable', data);
}

/**
 * @description 修改
 * @param {string}  userId
 * @param {string}  mobile
 * @param {string}  nickName
 * @param {string}  password
 * @param {string}  roleIds
 * @returns {}
 */

export function editTable(data) {
  return request.post('admin/user/edit', data);
}

/**
 * @description 新增
 * @param {string}  mobile
 * @param {string}  nickName
 * @param {string}  password
 * @param {string}  roleIds
 * @returns {}
 */

export function addTable(data) {
  // data.roleIds=data.roleId.join(",")
  return request.post('admin/user/store', data);
}

/**
 * @description 修改状态
 * @param {string}  mobile
 * @param {string}  status
 * @returns {}
 */

export function userStatus(data) {
  return request.post('admin/user/status', data);
}

// i18n标签接口
export function translateResource(data) {
  return request.post('admin/translate/resource', data);
}